import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Route, Switch, Redirect, generatePath } from "react-router-dom";

import {
  clearCards,
  plannerContainerOnLoad,
} from "features/planner/planner.actions";

import routePaths from "app/routePaths";
import { isViewer, isPlanner, isAdmin } from "utils/app.util";
import { getCurrentUserAppRolesFromState } from "app/app.selectors";
import ViewContainer from "features/planner/components/View/ViewContainer";
import { getDefaultViewIdFromState } from "features/planner/planner.selectors";

class PlannerContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  componentWillUnmount() {
    const { dispatchClearCards } = this.props;
    dispatchClearCards();
  }

  render() {
    const { defaultViewId, currentUserAppRoles } = this.props;

    const currentUserOnlyHasViewerRole =
      isViewer(currentUserAppRoles) &&
      !isPlanner(currentUserAppRoles) &&
      !isAdmin(currentUserAppRoles);

    return (
      <Switch>
        {currentUserOnlyHasViewerRole && (
          <Redirect to={routePaths.reports} from={routePaths.root} />
        )}
        <Route
          path={routePaths.view}
          render={({ match }) => <ViewContainer {...match.params} />}
        />
        {!!defaultViewId && (
          <Redirect
            from={routePaths.root}
            to={generatePath(routePaths.view, { viewId: defaultViewId })}
          />
        )}
      </Switch>
    );
  }
}

export default compose(
  connect(
    state => ({
      defaultViewId: getDefaultViewIdFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
    }),
    {
      dispatchClearCards: clearCards,
      dispatchOnLoad: plannerContainerOnLoad,
    },
  ),
)(PlannerContainer);
